export default __webpack_public_path__ + "static/media/img_prof_2048.8d274bb2.jpeg";